var $grid = $('.grid.models-collection').masonry({
  itemSelector: '.photo-item',
  columnWidth: '.grid__col-sizer',
  gutter: '.grid__gutter-sizer',
  percentPosition: true,
  stagger: 30,
  // nicer reveal transition
  visibleStyle: { transform: 'translateY(0)', opacity: 1 },
  hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
});

//------------------//

// Get an API key for your demos at https://unsplash.com/developers
var unsplashID = '9ad80b14098bcead9c7de952435e937cc3723ae61084ba8e729adb642daf0251';

// get Masonry instance
var msnry = $grid.data('masonry');

$grid.infiniteScroll({
  // path: function() {
  //   return 'https://api.unsplash.com/photos?client_id='
  //     + unsplashID + '&page=' + this.pageIndex;
  // },
  path: function() {
    return 'https://thugmart.myshopify.com/collections.json?page=' + '?page=' + this.pageIndex;
  },
  // load response as flat text
  responseType: 'text',
  outlayer: msnry,
  status: '.page-load-status',
  history: false,
});

$grid.on( 'load.infiniteScroll', function( event, response ) {
  //console.log( response )
  // parse response into JSON data
  var data = JSON.parse( response );
  // compile data into HTML
  var itemsHTML = data.collections.map( getItemHTML ).join('');
  // convert HTML string into elements
  var $items = $( itemsHTML );
  // append item elements
  $items.imagesLoaded( function() {
    $grid.infiniteScroll( 'appendItems', $items )
      .masonry( 'appended', $items );
  })
});

// load initial page
$grid.infiniteScroll('loadNextPage');

//------------------//

var itemTemplateSrc = $('#photo-item-template').html();

function getItemHTML( photo ) {
   // return microTemplate( itemTemplateSrc, photo );

   var img = photo.image.src;
   var extension = (/[.]/.exec(img)) ? /[^.]+$/.exec(img) : undefined;
   var rnd_ext = [ '_380x420_','_380x500_','_380x300_', '_380x450_' ];
   var rand_size = rnd_ext[Math.floor(Math.random() * rnd_ext.length)];

   var new_img = img.replace('.' + extension[0], rand_size + 'cropped.'+ extension[0]);

   return '<div class="photo-item">' +
      '<img class="photo-item__image" src="'+ new_img  +'"  />'+
     '</div>';

  // Grab the template script

}

// micro templating, sort-of
function microTemplate( src, data ) {
  // // replace {{tags}} in source
  // return src.replace(/\{\{([\w\-_\.]+)\}\}/gi, function( match, key ) {
  //   // walk through objects to get value
  //   console.log(key);
  //   var value = data;
  //   key.split('.').forEach( function( part ) {
  //     value = value[ part ];
  //   });
  //   return value;
  // });


}
